import { IOfferScopeAllLang } from '../../../types/lang'
import { offerScopeCrudModalLang } from './offerScopeCrudModal'
import { offerScopePageLang } from './offerScopePage'
import { offerScopeListTableLang } from './offerScopeListTable'

export const offerScopeAllLang: IOfferScopeAllLang = {
	...offerScopePageLang,
	...offerScopeCrudModalLang,
	...offerScopeListTableLang
}